export default () => ({
  currentFolder: null,
  filteredSpeedDialContacts: [],
  speedDialContacts: [],
  currentContact: null
})
